import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import Select, { Props as ReactSelectProps } from 'react-select';

type SelectControlledProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<ReactSelectProps, 'value' | 'onChange' | 'name' | 'inputRef'> & {
    onlyView?: boolean;
  };

export function SelectControlled<T extends FieldValues = FieldValues>(
  props: SelectControlledProps<T>,
) {
  const {
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
    onlyView = false,
    ...selectProps
  } = props;

  return (
    <Controller
      name={name}
      rules={rules}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      control={control}
      render={({ field, fieldState }) => (
        <Select
          {...selectProps}
          name={field.name}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          isDisabled={onlyView}
          styles={{
            indicatorSeparator: () => ({}),
            container: (styles) => ({
              ...styles,
              width: '100%',
              margin: '0 auto',
            }),
          }}
          className="react-select"
          classNamePrefix="react-select"
        />
      )}
    />
  );
}
